import React, { useRef } from "react";
import { Controller } from "react-hook-form";
import { InputMask } from "primereact/inputmask";
import { FloatLabel } from "primereact/floatlabel";

const MaskInput = ({
  name,
  label,
  control,
  errors,
  mask,
  placeholder,
  onComplete,
  isRequired,
  preValue,
  className,
  onChange,
}) => {
  const inputRef = useRef(null);
  const handleFocusWithRef = () => {
    if (inputRef.current) {
      const inputElement = inputRef.current.getInput
        ? inputRef.current.getInput()
        : inputRef.current;
      if (inputElement) {
        inputElement.selectionStart = 0;
        inputElement.selectionEnd = 0;
      }
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: isRequired ? "Campo obrigatório." : false }}
      render={({ field, fieldState }) => (
        <>
          <label
            htmlFor={field.name}
            className={fieldState.error ? "p-error" : ""}
          ></label>
          <FloatLabel className="w-100">
            <InputMask
              id={field.name}
              value={
                preValue && field.value === undefined ? preValue : field.value
              }
              mask={mask}
              placeholder={placeholder}
              autoClear={true}
              ref={inputRef}
              className={`w-100 form-control ${
                fieldState.error ? "is-invalid" : ""
              } me-3 ${className}`}
              onChange={(e) => {
                field.onChange(e.target.value);
                onChange && onChange(e);
              }}
              onFocus={handleFocusWithRef}
              onComplete={(e) => {
                onComplete && onComplete(e.value);
              }}
            />
            <label htmlFor={field.name}>{label}</label>
          </FloatLabel>

          {errors && errors[name] && (
            <span className="p-error">{errors[name].message}</span>
          )}
        </>
      )}
    />
  );
};

export default MaskInput;
